'use client';

import { VStack } from '@chakra-ui/react';

import { BenefitsTypesSection } from './components/BenefitsTypesSection';
import { ExplanationSection } from './components/ExplanationSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { IntroductionSection } from './components/IntroductionSection';

interface Props {
  content: BenefitsPageContent;
}

export type BenefitsPageProps = Props;

const BenefitsPage = () => {
  return (
    <VStack width="full" spacing={0}>
      <IntroductionSection />

      <ExplanationSection />

      <BenefitsTypesSection />

      <HowItWorksSection />
    </VStack>
  );
};

export default BenefitsPage;
